import { Guid } from "guid-typescript";
import { CommunicationSetting } from "../interfaces/Index";
import { Service } from "./Service";

const endpoint = "CommunicationSetting";
export const CommunicationSettingService = {
	endpoint,
	getAll: async () => await Service.getAll(endpoint),
	getSingleById: async (id: number) => await Service.getSingleById(endpoint, id),
	getSingleByLookupId: async (id: Guid) => await Service.getSingleByLookupId(endpoint, id),
	updateSingleById: async (id: number, data: CommunicationSetting) => await Service.updateSingleById(endpoint, id, data)
}